<template>
  <div id="app">
    <router-view></router-view>
    <FloatingBack />
  </div>
</template>

<script>
export default {
  data () {
    return {
      timer: '',
      oldTime: ''
    }
  },

  created () {
    this.findTime()
    const u = navigator.userAgent
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    const style = document.createElement('style')
    style.type = 'text/css'
    if (isiOS) {
      style.innerText = "@font-face {font-family:'PingFang-Regular';src:url('./assets/font/pingfang.ttf')} * {font-family: 'PingFang-Regular'}"
    } else {
      style.innerText = "@font-face {font-family:'Roboto';src:url('./assets/font/Roboto-Regular.ttf')} * {font-family: 'Roboto'}"
    }
    document.getElementsByTagName('head')[0].appendChild(style)
  },

  methods: {
    findTime () {
      const that = this
      that.oldTime = this.$store.state.versionTime
      clearInterval(that.timer)
      that.timer = ''
      that.timer = setInterval(_ => {
        const time = new Date()
        if (time - that.oldTime > 1000 * 6 * 60 * 12) {
          that.$store.commit('setOpenId', '')
          that.$store.commit('setIsFirst', '')
          that.$store.commit('setVersionTime', new Date().getTime())
          if (location.href.split('?') > 1) {
            location.href = location.href.split('?')[0] + '#/' + location.href.split('?')[1].split('#/')[1]
          } else {
            window.location.reload(true)
          }
        }
      }, 1000)
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<style scoped lang='less'>
/* 确保 #app 占满全屏，避免布局塌陷 */
#app {
  width: 100%;
  height: 100%;
}
</style>
